import styled from '@emotion/styled';
import { Button, Dialog, DialogContent } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import { DialogActionsWithSlots } from '../../../../../../components/DialogActionsWithSlots';
import { DialogTitleWithTypography } from '../../../../../../components/DialogTitleWithTypography';
import { useTranslation } from '../../../../../../i18next';

const Content = styled(DialogContent)((p) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: p.theme.spacing(2)
}));

type Props = {
  name: string;
  open: boolean;
  onClose: () => void;
};

/**
 * Loading placeholder rendered while an integration's connection-status
 * call is in flight. Mirrors the layout of a real setup dialog so the
 * skeleton to content transition doesn't jump.
 */
export const IntegrationSetupDialogSkeleton = ({
  name,
  open,
  onClose
}: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitleWithTypography>
        {name} {t('org.integrations.integration')}
      </DialogTitleWithTypography>
      <Content>
        <Skeleton />
        <Skeleton />
      </Content>
      <DialogActionsWithSlots
        right={
          <Button color="primary" onClick={onClose}>
            {t('Close')}
          </Button>
        }
      />
    </Dialog>
  );
};
